import React, {Component} from 'react';
import {connect} from 'react-redux';
import Ionicon from "react-ionicons";
import {changeVisibility} from '../../../actions';

class SideNavPublishButton extends Component {
    render() {
        const {
            personId, visible, networkId, dispatch, experience, summary, openWarningModal
        } = this.props;
        const noSummaryAndExperience = ((summary.noData) || (!experience));

        return (
            <span>
                    {
                        noSummaryAndExperience ?
                            <span>{ (visible === 1) ?
                                <span>{
                                    (visible === 1) ?
                                        <button className="theme-button secondary"
                                                onClick={ () => dispatch(changeVisibility(personId, 0, networkId)) }>
                                            Unpublish
                                            <i className="fa fa-eye-slash button-icon"/>
                                        </button>
                                        :
                                        <button className="theme-button"
                                                onClick={ () => dispatch(changeVisibility(personId, 1, networkId)) }>
                                            Publish
                                            <i className="fa fa-eye button-icon"/>
                                        </button>
                                }
                            </span> :
                                <button className="theme-button"
                                        onClick={ () => openWarningModal() }>
                                    Publish
                                    <i className="fa fa-eye"/>
                                </button>  }
                                </span>
                            :

                            <span>{
                                (visible === 1) ?
                                    <button className="theme-button secondary"
                                            onClick={ () => dispatch(changeVisibility(personId, 0, networkId)) }>
                                        Unpublish
                                        <i className="fa fa-eye-slash button-icon"/>
                                    </button>
                                    :
                                    <button className="theme-button"
                                            onClick={ () => dispatch(changeVisibility(personId, 1, networkId)) }>
                                        Publish
                                        <i className="fa fa-eye button-icon"/>
                                    </button>
                            }</span>
                    }
                </span>
        )
    }
}

export default connect()(SideNavPublishButton);




// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/body/visibility/SideNavPublishButton.js